import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { OrderService } from '../../Services/order.service';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss'
})
export class CounterComponent {

  input_color = input.required<String>();
  id = input.required<number>();
  price = input.required<number>();
  
  @Output() orderSuccess = new EventEmitter<void>();
  @Output() orderDelete = new EventEmitter<void>();

  
  UserOrder = inject(OrderService);


  number = 0;
  ngOnInit(): void {
    // Ensure `id` is defined before using it
    this.number = this.UserOrder.getAmount(this.id());
  }
  MinusClicked(){
    if(this.number > 0){
      this.number--;
      this.UserOrder.decreaseAmount(this.id());
      this.orderDelete.emit();  
    }

  }
  PlusClicked(){
    this.number++;
    this.UserOrder.addOrder(this.id(), this.price());
    this.orderSuccess.emit(); 
  }
}
